import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "20",
  fill: "none",
  viewBox: "0 0 19 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4B5563",
      "fill-rule": "evenodd",
      d: "M12.773 2.058c.22.244.22.64 0 .884L6.42 10l6.353 7.058c.22.244.22.64 0 .884a.524.524 0 0 1-.796 0l-6.75-7.5a.675.675 0 0 1 0-.884l6.75-7.5a.524.524 0 0 1 .796 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }